import { transport } from 'config/transport';

export function callApiChangePasswordUser(username, body) {
    return transport.post(`/trunguong/${username}/changepassword`, body);
}
